document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".article-wysiwyg-content p").forEach(function (paragraph) {
    const anchor = paragraph.querySelector(":scope > a");

    if (!anchor) {
      return;
    }

    let elementChildren = 0;
    let hasMeaningfulText = false;

    paragraph.childNodes.forEach(function (node) {
      if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.tagName === "A" && node === anchor) {
          elementChildren += 1;
          return;
        }

        elementChildren += 1;
        return;
      }

      if (node.nodeType === Node.TEXT_NODE) {
        const text = (node.textContent || "").replace(/\u00a0/g, "").trim();

        if (text !== "") {
          hasMeaningfulText = true;
        }
      }
    });

    if (elementChildren === 1 && !hasMeaningfulText) {
      anchor.classList.add("wysiwyg-auto-button");
    }
  });
});
